import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const ModalWrapper = styled.div.attrs(() => ({
  className: e2eClasses('corporate.recoverCredentialsBox')
}))`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.regular};
  ${mediaQueries.mobile`
    min-height: 50%
  `}
`
export const ModalHeaderWrapper = styled.div.attrs(() => ({
  className: e2eClasses('corporate.recoverCredentialsHeader')
}))`
  display: flex;
  justify-content: space-between;
  padding: ${({ padding }) => padding || '5px 40px'};
  ${({ autoHeight, height }) => !autoHeight && `height: ${height || '80px'};`}
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${mediaQueries.mobile`
    border-bottom: 4px solid ${({ theme }) => theme.colors.gray10};
    padding: 5px 20px;
  `}
`
export const InteractiveIconContainer = styled.button.attrs(() => ({
  className: e2eClasses('corporate.recoverCredentialsCloseIcon')
}))`
  margin-left: 10px;
  align-self: ${({ alignSelf }) => alignSelf || 'flex-start'};
  ${({ position }) =>
    position &&
    css`
      position: ${position};
      ${({ top }) => top && `top: ${top};`}
      ${({ right }) => right && `right: ${right};`}
    `}

  &:hover {
    cursor: pointer;
  }
`
export const ModalContentWrapper = styled.div`
  display: flex;
  padding: 0 40px;
  margin: ${({ margin }) => margin || '10px 0 20px 0'};
  flex-direction: column;
  ${mediaQueries.mobile`
    padding: 0 20px;
  `}
`
